"use client"

import Navbar from "../component/Navbar";
import FinalForm from "../component/FinalForm";
import HealthcareExpert from "../component/HealthcareExpert";
import LocationSection from "../component/LocationSection";
import Footer from "../component/Footer";
import BackToTop from "../component/BackToTop";

export default function ContactPage() {
  return (
    <div>
      <Navbar />
      <FinalForm />
      <LocationSection />
      <HealthcareExpert />

      <Footer />
<BackToTop />
    </div>
  );
}
